var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SuccessScreen',[_c('p',{staticClass:"ref has-text-centered"},[_vm._v("Ref No. "+_vm._s(_vm.accountReferenceNumber))]),_c('p',{staticClass:"date has-text-centered"},[_vm._v(_vm._s(_vm.accountDate))])])}
var staticRenderFns = []

export { render, staticRenderFns }